import { Routes } from '@angular/router';
import { StockSearchComponent } from './pages/stock-search/stock-search.component';
import { LandingComponent } from './pages/landing/landing.component';
import { LoadVehiclesComponent } from './pages/load-vehicle/load-vehicles.component';
import { UsersComponent } from './pages/users/users.component';
import { AuthGuard } from './guards/auth.guard';


export const appRoutes: Routes = [
  { path: '', canActivate: [AuthGuard], component: LandingComponent },
  { path: 'landing', canActivate: [AuthGuard], component: LandingComponent },
  { path: 'stock-search', canActivate: [AuthGuard], component: StockSearchComponent },
  { path: 'users', canActivate: [AuthGuard], component: UsersComponent },
  { path: 'load-vehicles', canActivate: [AuthGuard], component: LoadVehiclesComponent },
  { path: '**', canActivate: [AuthGuard], redirectTo: '', pathMatch: 'full' },
];
